let isRouterInitialized = false;

export const markRouterInitialized = () => {
  isRouterInitialized = true;
};

export const preloadRoute = (loadModule: () => Promise<unknown>) => async () => {
  if (isRouterInitialized) {
    await loadModule();
  }
  return {};
};
